import {putMethod} from '~/api'

async function put(request) {
    return await putMethod(`/api/voidFlightTicket?processId=${request.processId}`)
}

export {put}
